var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loading'):_c('switch-selector',{attrs:{"filterable":false,"data":_vm.mappedDelegates,"selected":_vm.newSelection,"disabled":_vm.isProcessing},on:{"select":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }